import React, { useState } from "react";
import axios from "axios";
import { ArrowRight, MessageCircle, Mail, Check } from "lucide-react";
import { WHATSAPP_URL, CONTACT_EMAIL, EMAIL_COMPOSE_URL } from "../constants";
import { useSite } from "../contexts/SiteContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Contact = () => {
  const { content } = useSite();
  const c = content.contact || {};
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setErrorMsg("Por favor completa todos los campos.");
      setStatus("error");
      return;
    }
    setStatus("loading");
    setErrorMsg("");
    try {
      await axios.post(`${API}/contact`, form);
      setStatus("success");
    } catch (err) {
      setErrorMsg(err?.response?.data?.detail || "No se pudo enviar tu mensaje. Inténtalo de nuevo.");
      setStatus("error");
    }
  };

  return (
    <section id="contacto" style={{ padding: "60px 24px 90px" }}>
      <div style={{ maxWidth: 1240, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 1.1fr", gap: 56, alignItems: "start" }} className="contact-grid">
        <div className="fade-in">
          <span className="pill" style={{ marginBottom: 16 }}>
            <span style={{ width: 18, height: 1, background: "#1A1352" }} /> {c.kicker}
          </span>
          <h2 className="h-display" style={{ fontSize: "clamp(32px, 4.4vw, 56px)", margin: "12px 0 18px" }}>
            <span className="text-grad-purple">{c.titleLine1}<br />{c.titleLine2}<br />{c.titleLine3}</span>
          </h2>
          <p style={{ color: "#5F5A72", fontSize: 16, lineHeight: 1.6, marginBottom: 30, maxWidth: 460 }}>{c.subtitle}</p>

          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer"
            style={{ display: "flex", alignItems: "center", gap: 16, padding: "18px 22px", background: "#fff", borderRadius: 18, border: "1px solid rgba(26,19,82,0.08)", textDecoration: "none", marginBottom: 14, transition: "transform 220ms ease, box-shadow 220ms ease" }}
            onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 14px 28px -10px rgba(26,19,82,0.18)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}>
            <span style={{ width: 44, height: 44, borderRadius: 12, background: "rgba(37,211,102,0.14)", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
              <MessageCircle size={20} color="#25D366" />
            </span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, color: "#1A1352", fontSize: 16 }}>WhatsApp</div>
              <div style={{ color: "#5F5A72", fontSize: 13 }}>Chatea con nuestro equipo</div>
            </div>
            <ArrowRight size={18} color="#1A1352" />
          </a>

          <a href={EMAIL_COMPOSE_URL} target="_blank" rel="noopener noreferrer"
            style={{ display: "flex", alignItems: "center", gap: 16, padding: "18px 22px", background: "#fff", borderRadius: 18, border: "1px solid rgba(26,19,82,0.08)", textDecoration: "none", transition: "transform 220ms ease, box-shadow 220ms ease" }}
            onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 14px 28px -10px rgba(26,19,82,0.18)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}>
            <span style={{ width: 44, height: 44, borderRadius: 12, background: "rgba(84,70,234,0.12)", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
              <Mail size={20} color="#5446EA" />
            </span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, color: "#1A1352", fontSize: 16 }}>Email</div>
              <div style={{ color: "#5F5A72", fontSize: 13 }}>{CONTACT_EMAIL}</div>
            </div>
          </a>
        </div>

        <div className="fade-in">
          {status !== "success" ? (
            <form onSubmit={handleSubmit} style={{ background: "#fff", borderRadius: 24, padding: 32, border: "1.5px solid rgba(84,70,234,0.18)", boxShadow: "0 20px 50px -25px rgba(26,19,82,0.18)" }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }} className="contact-row">
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: "#1A1352", display: "block", marginBottom: 6 }}>Nombre</label>
                  <input className="ae-input" name="name" value={form.name} onChange={handleChange} placeholder="Tu nombre" required />
                </div>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: "#1A1352", display: "block", marginBottom: 6 }}>Email</label>
                  <input className="ae-input" type="email" name="email" value={form.email} onChange={handleChange} placeholder="tu@correo.com" required />
                </div>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: "#1A1352", display: "block", marginBottom: 6 }}>Mensaje</label>
                <textarea className="ae-input" name="message" value={form.message} onChange={handleChange} placeholder="En qué podemos ayudarte?" rows={5} required style={{ resize: "vertical", minHeight: 120 }} />
              </div>
              {status === "error" && <div style={{ color: "#E83E0A", fontSize: 13, marginBottom: 12 }}>{errorMsg}</div>}
              <button type="submit" className="btn-orange" disabled={status === "loading"} style={{ width: "100%", justifyContent: "center", opacity: status === "loading" ? 0.7 : 1 }}>
                {status === "loading" ? "Enviando..." : "Enviar mensaje"}
                {status !== "loading" && <ArrowRight size={16} />}
              </button>
            </form>
          ) : (
            <div style={{ background: "#fff", borderRadius: 24, padding: "56px 32px", border: "1.5px solid rgba(84,70,234,0.25)", boxShadow: "0 20px 50px -25px rgba(26,19,82,0.18)", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: 16, minHeight: 360, justifyContent: "center" }}>
              <span style={{ width: 72, height: 72, borderRadius: 999, background: "rgba(84,70,234,0.14)", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                <Check size={32} color="#5446EA" strokeWidth={3} />
              </span>
              <h3 className="h-display" style={{ fontSize: 26, margin: 0 }}>{c.successTitle}</h3>
              <p style={{ color: "#5F5A72", fontSize: 15, lineHeight: 1.55, margin: 0, maxWidth: 380 }}>{c.successSubtitle}</p>
            </div>
          )}
        </div>
      </div>
      <style>{`@media (max-width: 900px){.contact-grid{grid-template-columns:1fr !important;gap:32px !important;}.contact-row{grid-template-columns:1fr !important;}}`}</style>
    </section>
  );
};

export default Contact;
